(function (global) {
    class Control {
        constructor(form, config) {
            this.init(form, config);
        }

        init(form, config) {
            this.form = form;
            this.options = new NS.Utils.OptionsResolver(config);
            this.dataProcessor = null;
            this.blockPrefix = this.options.getOption("block-prefix");

            this.configure();
            this.initListeners();
        }

        // noinspection JSUnusedLocalSymbols
        configure() {
            const url = this.options.getOption("url");

            if (!url) {
                throw new Error("Form url is not defined.");
            }

            // noinspection JSPotentiallyInvalidConstructorUsage
            const formDataProcessor = new dataProcessor(url);
            formDataProcessor.init(this.form);
            formDataProcessor.setTransactionMode("REST", true);
            formDataProcessor.setUpdateMode("off");
            formDataProcessor.enableDataNames(true);
            formDataProcessor.enableDebug(true);

            // noinspection JSUnusedLocalSymbols
            formDataProcessor.defineAction("invalid", function (response) {
                return true;
            });

            if (this.options.getOption("add-url-trailing-slash", true)) {
                //Obsługa dodawania "trailing slash" do URL-a przy aktualizacji obiektu.
                // noinspection JSUnusedLocalSymbols
                formDataProcessor.attachEvent("onBeforeDataSending", function (id, state, data) {
                    formDataProcessor.serverProcessor = url;

                    if (state === "updated" || state === "deleted") {
                        formDataProcessor.serverProcessor = url + "/";
                    }

                    return true;
                });
            }

            this.dataProcessor = formDataProcessor;
        }

        initListeners() {
            const me = this;
            const handlers = this.options.getOption("handlers", {});

            this.form.attachEvent("onButtonClick", function (id) {
                const handlerName = id + "-click";

                if (typeof handlers[handlerName] == "function") {
                    handlers[handlerName].call(me, me);
                }
                else if (typeof handlers[handlerName] == "object") {
                    const scope = handlers[handlerName]["scope"] ? handlers[handlerName]["scope"] : me;

                    if (typeof handlers[handlerName]["function"] != "function") {
                        throw new Error("Handler for button: " + id + " is object, but do not have 'function' property.");
                    }

                    handlers[handlerName]["function"].call(scope, me);
                }
            });

            this.form.attachEvent("onAfterSave", function (id, response){
                if (response["errors"] != null) {
                    me.manageErrors(response["errors"]);
                    me.form.resetDataProcessor(response["action"]);
                }

                return response["action"] !== "invalid" && response["action"] !== "error";
            });
        }

        save() {
            const me = this;

            //Czyszczenie komunikatów walidacyjnych
            this.form.forEachItem(function (name) {
                me.markFieldError(name, true);
            });

            this.form.save();
        }

        dhtmlxObject() {
            return this.form;
        }

        markFieldError(fullFieldName, isValid, error) {
            if (!this.form.isItem(fullFieldName)) {
                console && console.warn("Field: " + fullFieldName + " does not exists.");
                return;
            }

            const itemType = this.form.getItemType(fullFieldName);

            if (itemType === "block" || itemType === "button") {
                return;
            }

            this.form.setValidateCss(fullFieldName, isValid);

            if (isValid) {
                this.form.clearNote(fullFieldName);
            }
            else {
                this.form.setNote(fullFieldName, {
                    "text": error
                });
            }
        }

        manageErrors(errors) {
            for (let fieldName in errors) {
                if (!errors.hasOwnProperty(fieldName)) {
                    continue;
                }

                const error = errors[fieldName];

                const fullFieldName = this.blockPrefix + "[" + fieldName + "]";

                this.markFieldError(fullFieldName, false, error);
            }
        }
    }

    global.NS = global.NS || {};
    global.NS.Form = global.NS.Form || {};
    global.NS.Form.Control = Control;
})(window);
